$(document).ready(function () { 
  function addRechargeWidget(productid){
    const config = {
      productId: productid, // Required
      injectionParent: '#add-item-form', // The node that will have the widget injected in
      injectionMethod: 'prepend', // How will the widget be injected 
      injectFn: (node, target) => {}, // Runs a custom injection function 
    };
    window.ReChargeWidget.createWidget(config);
  }
  
function displayQuickViewModal(producturl, productid) {
  const existingModal = $(".quickview-modal-wrapper");
  if (existingModal) existingModal.remove()
  const modal = $('<div>').addClass("quickview-modal-wrapper");
  $.ajax({
    type: 'GET',
    url: producturl + "?view=quickview",
    // dataType: 'html',
    success: function(html) {
      modal.html(`
        <div class="quickview-modal-backdrop"></div>
        <div class="quickview-modal-content">
          <button class="quickview-close-btn">
             <svg xmlns="http://www.w3.org/2000/svg" fill="white" height="24" viewBox="0 -960 960 960" width="24">
                <path
                    d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
            </svg>
          </button>
          ${html}
        </div>
      `);
      $('body').css('overflow', 'hidden');
      $('body').append(modal);
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();

      try{
        addRechargeWidget(productid);
      }catch(err){
        console.log(err)
      }
      function removeModal(){
       $(".quickview-modal-wrapper").each(function(){
         $(this).remove()
         $('body').css('overflow', 'auto');
         window.ReChargeWidget.destroyWidgets();
       })
      }
      
      $('.quickview-close-btn').on('click', removeModal)
      $('.quickview-modal-backdrop').on('click', removeModal)
    },
    error: function(err) {
      console.log("Error loading quickview modal: ", err);
    }
  });
}

  $('.quickview-btn').on('click', function(){
    var productUrl = $(this).data('product-url');
    var productId = $(this).data('product-id');
    displayQuickViewModal(productUrl, productId)
  })
})

window['ThemeSection_ProductQuickViewBuy'] = ({
  product,
  variant
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    addedToCart: false,
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;
      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }
    },
    submitForm(evt) {
      evt.preventDefault();
      this.loading = true;

      liveRegion(window.theme.strings.loading);
      const formData = new FormData(
        this.$root.querySelector('.quickview-buy-product-form')
      );

      const config = fetchConfigDefaults('javascript');

      formData.append('sections', 'cart-items,cart-footer,cart-item-count');
      formData.append('sections_url', window.location.pathname);

      config.body = formData;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          this.loading = false;
          this.addedToCart = true;

            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          error.json().then((a) => {
            this.loading = false;
            alert(a.description);
          });
        });
    },
  };
};
